module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M21 24H11a1 1 0 0 1-1-1v-1H0v8c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2v-8H22v1a1 1 0 0 1-1 1zm3-18V2c0-1.106-.894-2-2-2H10C8.894 0 8 .894 8 2v4H2C.894 6 0 6.894 0 8v12h10v-3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v3h10V8c0-1.106-.894-2-2-2h-6zm-4 0h-8V4h8v2zm0 13a1 1 0 0 0-1-1h-6a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/toolbox-1.js
// module id = 1453
// module chunks = 14